import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=a0d58f14&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=ts"
export * from "./Menu.vue?vue&type=script&lang=ts"
import style0 from "./Menu.vue?vue&type=style&index=0&id=a0d58f14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d58f14",
  null
  
)

export default component.exports